type CountryCodeMap = Record<string, string>;

export const CountryCodeMap: any = {
  Afghanistan: { phonePrefix: '+93', countryCode: 'AF' },
  'Aland Islands': { phonePrefix: '+358', countryCode: 'AX' },
  Albania: { phonePrefix: '+355', countryCode: 'AL' },
  Algeria: { phonePrefix: '+213', countryCode: 'DZ' },
  'American Samoa': { phonePrefix: '+1684', countryCode: 'AS' },
  Andorra: { phonePrefix: '+376', countryCode: 'AD' },
  Angola: { phonePrefix: '+244', countryCode: 'AO' },
  Anguilla: { phonePrefix: '+1264', countryCode: 'AI' },
  Antarctica: { phonePrefix: '+672', countryCode: 'AQ' },
  'Antigua and Barbuda': { phonePrefix: '+1268', countryCode: 'AG' },
  Argentina: { phonePrefix: '+54', countryCode: 'AR' },
  Armenia: { phonePrefix: '+374', countryCode: 'AM' },
  Aruba: { phonePrefix: '+297', countryCode: 'AW' },
  Australia: { phonePrefix: '+61', countryCode: 'AU' },
  Austria: { phonePrefix: '+43', countryCode: 'AT' },
  Azerbaijan: { phonePrefix: '+994', countryCode: 'AZ' },
  Bahamas: { phonePrefix: '+1242', countryCode: 'BS' },
  Bahrain: { phonePrefix: '+973', countryCode: 'BH' },
  Bangladesh: { phonePrefix: '+880', countryCode: 'BD' },
  Barbados: { phonePrefix: '+1246', countryCode: 'BB' },
  Belgium: { phonePrefix: '+32', countryCode: 'BE' },
  Belize: { phonePrefix: '+501', countryCode: 'BZ' },
  Benin: { phonePrefix: '+229', countryCode: 'BJ' },
  Bermuda: { phonePrefix: '+1441', countryCode: 'BM' },
  Bhutan: { phonePrefix: '+975', countryCode: 'BT' },
  'Bolivia, Plurinational State of': { phonePrefix: '+591', countryCode: 'BO' },
  'Bosnia and Herzegovina': { phonePrefix: '+387', countryCode: 'BA' },
  Botswana: { phonePrefix: '+267', countryCode: 'BW' },
  Brazil: { phonePrefix: '+55', countryCode: 'BR' },
  'British Indian Ocean Territory': { phonePrefix: '+246', countryCode: 'IO' },
  'Brunei Darussalam': { phonePrefix: '+673', countryCode: 'BN' },
  Bulgaria: { phonePrefix: '+359', countryCode: 'BG' },
  'Burkina Faso': { phonePrefix: '+226', countryCode: 'BF' },
  Burundi: { phonePrefix: '+257', countryCode: 'BI' },
  Cambodia: { phonePrefix: '+855', countryCode: 'KH' },
  Cameroon: { phonePrefix: '+237', countryCode: 'CM' },
  Canada: { phonePrefix: '+1', countryCode: 'CA' },
  'Cape Verde': { phonePrefix: '+238', countryCode: 'CV' },
  'Cayman Islands': { phonePrefix: '+ 345', countryCode: 'KY' },
  'Central African Republic': { phonePrefix: '+236', countryCode: 'CF' },
  Chad: { phonePrefix: '+235', countryCode: 'TD' },
  Chile: { phonePrefix: '+56', countryCode: 'CL' },
  China: { phonePrefix: '+86', countryCode: 'CN' },
  'Christmas Island': { phonePrefix: '+61', countryCode: 'CX' },
  'Cocos (Keeling) Islands': { phonePrefix: '+61', countryCode: 'CC' },
  Colombia: { phonePrefix: '+57', countryCode: 'CO' },
  Comoros: { phonePrefix: '+269', countryCode: 'KM' },
  Congo: { phonePrefix: '+242', countryCode: 'CG' },
  'Cook Islands': { phonePrefix: '+682', countryCode: 'CK' },
  'Costa Rica': { phonePrefix: '+506', countryCode: 'CR' },
  "Cote d'Ivoire": { phonePrefix: '+225', countryCode: 'CI' },
  Croatia: { phonePrefix: '+385', countryCode: 'HR' },
  Cuba: { phonePrefix: '+53', countryCode: 'CU' },
  Cyprus: { phonePrefix: '+357', countryCode: 'CY' },
  'Czech Republic': { phonePrefix: '+420', countryCode: 'CZ' },
  Denmark: { phonePrefix: '+45', countryCode: 'DK' },
  Djibouti: { phonePrefix: '+253', countryCode: 'DJ' },
  Dominica: { phonePrefix: '+1767', countryCode: 'DM' },
  'Dominican Republic': { phonePrefix: '+1849', countryCode: 'DO' },
  Ecuador: { phonePrefix: '+593', countryCode: 'EC' },
  Egypt: { phonePrefix: '+20', countryCode: 'EG' },
  'El Salvador': { phonePrefix: '+503', countryCode: 'SV' },
  'Equatorial Guinea': { phonePrefix: '+240', countryCode: 'GQ' },
  Eritrea: { phonePrefix: '+291', countryCode: 'ER' },
  Estonia: { phonePrefix: '+372', countryCode: 'EE' },
  Ethiopia: { phonePrefix: '+251', countryCode: 'ET' },
  'Falkland Islands (Malvinas)': { phonePrefix: '+500', countryCode: 'FK' },
  'Faroe Islands': { phonePrefix: '+298', countryCode: 'FO' },
  Fiji: { phonePrefix: '+679', countryCode: 'FJ' },
  Finland: { phonePrefix: '+358', countryCode: 'FI' },
  France: { phonePrefix: '+33', countryCode: 'FR' },
  'French Guiana': { phonePrefix: '+594', countryCode: 'GF' },
  'French Polynesia': { phonePrefix: '+689', countryCode: 'PF' },
  Gabon: { phonePrefix: '+241', countryCode: 'GA' },
  Gambia: { phonePrefix: '+220', countryCode: 'GM' },
  Georgia: { phonePrefix: '+995', countryCode: 'GE' },
  Germany: { phonePrefix: '+49', countryCode: 'DE' },
  Ghana: { phonePrefix: '+233', countryCode: 'GH' },
  Gibraltar: { phonePrefix: '+350', countryCode: 'GI' },
  Greece: { phonePrefix: '+30', countryCode: 'GR' },
  Greenland: { phonePrefix: '+299', countryCode: 'GL' },
  Grenada: { phonePrefix: '+1473', countryCode: 'GD' },
  Guadeloupe: { phonePrefix: '+590', countryCode: 'GP' },
  Guam: { phonePrefix: '+1671', countryCode: 'GU' },
  Guatemala: { phonePrefix: '+502', countryCode: 'GT' },
  Guernsey: { phonePrefix: '+44', countryCode: 'GG' },
  Guinea: { phonePrefix: '+224', countryCode: 'GN' },
  'Guinea-Bissau': { phonePrefix: '+245', countryCode: 'GW' },
  Guyana: { phonePrefix: '+595', countryCode: 'GY' },
  Haiti: { phonePrefix: '+509', countryCode: 'HT' },
  'Holy See (Vatican City State)': { phonePrefix: '+379', countryCode: 'VA' },
  Honduras: { phonePrefix: '+504', countryCode: 'HN' },
  'Hong Kong': { phonePrefix: '+852', countryCode: 'HK' },
  Hungary: { phonePrefix: '+36', countryCode: 'HU' },
  Iceland: { phonePrefix: '+354', countryCode: 'IS' },
  India: { phonePrefix: '+91', countryCode: 'IN' },
  Indonesia: { phonePrefix: '+62', countryCode: 'ID' },
  Iraq: { phonePrefix: '+964', countryCode: 'IQ' },
  Ireland: { phonePrefix: '+353', countryCode: 'IE' },
  'Isle of Man': { phonePrefix: '+44', countryCode: 'IM' },
  Israel: { phonePrefix: '+972', countryCode: 'IL' },
  Italy: { phonePrefix: '+39', countryCode: 'IT' },
  Jamaica: { phonePrefix: '+1876', countryCode: 'JM' },
  Japan: { phonePrefix: '+81', countryCode: 'JP' },
  Jersey: { phonePrefix: '+44', countryCode: 'JE' },
  Jordan: { phonePrefix: '+962', countryCode: 'JO' },
  Kazakhstan: { phonePrefix: '+77', countryCode: 'KZ' },
  Kenya: { phonePrefix: '+254', countryCode: 'KE' },
  Kiribati: { phonePrefix: '+686', countryCode: 'KI' },
  Kuwait: { phonePrefix: '+965', countryCode: 'KW' },
  Kyrgyzstan: { phonePrefix: '+996', countryCode: 'KG' },
  Latvia: { phonePrefix: '+371', countryCode: 'LV' },
  Lebanon: { phonePrefix: '+961', countryCode: 'LB' },
  Lesotho: { phonePrefix: '+266', countryCode: 'LS' },
  Liberia: { phonePrefix: '+231', countryCode: 'LR' },
  Liechtenstein: { phonePrefix: '+423', countryCode: 'LI' },
  Lithuania: { phonePrefix: '+370', countryCode: 'LT' },
  Luxembourg: { phonePrefix: '+352', countryCode: 'LU' },
  Macao: { phonePrefix: '+853', countryCode: 'MO' },
  Madagascar: { phonePrefix: '+261', countryCode: 'MG' },
  Malawi: { phonePrefix: '+265', countryCode: 'MW' },
  Malaysia: { phonePrefix: '+60', countryCode: 'MY' },
  Maldives: { phonePrefix: '+960', countryCode: 'MV' },
  Mali: { phonePrefix: '+223', countryCode: 'ML' },
  Malta: { phonePrefix: '+356', countryCode: 'MT' },
  'Marshall Islands': { phonePrefix: '+692', countryCode: 'MH' },
  Martinique: { phonePrefix: '+596', countryCode: 'MQ' },
  Mauritania: { phonePrefix: '+222', countryCode: 'MR' },
  Mauritius: { phonePrefix: '+230', countryCode: 'MU' },
  Mayotte: { phonePrefix: '+262', countryCode: 'YT' },
  Mexico: { phonePrefix: '+52', countryCode: 'MX' },
  Monaco: { phonePrefix: '+377', countryCode: 'MC' },
  Mongolia: { phonePrefix: '+976', countryCode: 'MN' },
  Montenegro: { phonePrefix: '+382', countryCode: 'ME' },
  Montserrat: { phonePrefix: '+1664', countryCode: 'MS' },
  Morocco: { phonePrefix: '+212', countryCode: 'MA' },
  Mozambique: { phonePrefix: '+258', countryCode: 'MZ' },
  Namibia: { phonePrefix: '+264', countryCode: 'NA' },
  Nauru: { phonePrefix: '+674', countryCode: 'NR' },
  Nepal: { phonePrefix: '+977', countryCode: 'NP' },
  Netherlands: { phonePrefix: '+31', countryCode: 'NL' },
  'New Caledonia': { phonePrefix: '+687', countryCode: 'NC' },
  'New Zealand': { phonePrefix: '+64', countryCode: 'NZ' },
  Nicaragua: { phonePrefix: '+505', countryCode: 'NI' },
  Niger: { phonePrefix: '+227', countryCode: 'NE' },
  Niue: { phonePrefix: '+683', countryCode: 'NU' },
  'Norfolk Island': { phonePrefix: '+672', countryCode: 'NF' },
  'Northern Mariana Islands': { phonePrefix: '+1670', countryCode: 'MP' },
  Norway: { phonePrefix: '+47', countryCode: 'NO' },
  Oman: { phonePrefix: '+968', countryCode: 'OM' },
  Pakistan: { phonePrefix: '+92', countryCode: 'PK' },
  Palau: { phonePrefix: '+680', countryCode: 'PW' },
  Panama: { phonePrefix: '+507', countryCode: 'PA' },
  'Papua New Guinea': { phonePrefix: '+675', countryCode: 'PG' },
  Paraguay: { phonePrefix: '+595', countryCode: 'PY' },
  Peru: { phonePrefix: '+51', countryCode: 'PE' },
  Philippines: { phonePrefix: '+63', countryCode: 'PH' },
  Pitcairn: { phonePrefix: '+872', countryCode: 'PN' },
  Poland: { phonePrefix: '+48', countryCode: 'PL' },
  Portugal: { phonePrefix: '+351', countryCode: 'PT' },
  'Puerto Rico': { phonePrefix: '+1939', countryCode: 'PR' },
  Qatar: { phonePrefix: '+974', countryCode: 'QA' },
  Reunion: { phonePrefix: '+262', countryCode: 'RE' },
  Romania: { phonePrefix: '+40', countryCode: 'RO' },
  Rwanda: { phonePrefix: '+250', countryCode: 'RW' },
  'Saint Helena, Ascension and Tristan da Cunha': { phonePrefix: '+290', countryCode: 'SH' },
  'Saint Kitts and Nevis': { phonePrefix: '+1869', countryCode: 'KN' },
  'Saint Lucia': { phonePrefix: '+1758', countryCode: 'LC' },
  'Saint Pierre and Miquelon': { phonePrefix: '+508', countryCode: 'PM' },
  'Saint Vincent and the Grenadines': { phonePrefix: '+1784', countryCode: 'VC' },
  Samoa: { phonePrefix: '+685', countryCode: 'WS' },
  'San Marino': { phonePrefix: '+378', countryCode: 'SM' },
  'Sao Tome and Principe': { phonePrefix: '+239', countryCode: 'ST' },
  'Saudi Arabia': { phonePrefix: '+966', countryCode: 'SA' },
  Senegal: { phonePrefix: '+221', countryCode: 'SN' },
  Serbia: { phonePrefix: '+381', countryCode: 'RS' },
  Seychelles: { phonePrefix: '+248', countryCode: 'SC' },
  'Sierra Leone': { phonePrefix: '+232', countryCode: 'SL' },
  Singapore: { phonePrefix: '+65', countryCode: 'SG' },
  Slovakia: { phonePrefix: '+421', countryCode: 'SK' },
  Slovenia: { phonePrefix: '+386', countryCode: 'SI' },
  'Solomon Islands': { phonePrefix: '+677', countryCode: 'SB' },
  Somalia: { phonePrefix: '+252', countryCode: 'SO' },
  'South Africa': { phonePrefix: '+27', countryCode: 'ZA' },
  'South Georgia and the South Sandwich Islands': { phonePrefix: '+500', countryCode: 'GS' },
  'South Sudan': { phonePrefix: '+211', countryCode: 'SS' },
  Spain: { phonePrefix: '+34', countryCode: 'ES' },
  'Sri Lanka': { phonePrefix: '+94', countryCode: 'LK' },
  Sudan: { phonePrefix: '+249', countryCode: 'SD' },
  Suriname: { phonePrefix: '+597', countryCode: 'SR' },
  'Svalbard and Jan Mayen': { phonePrefix: '+47', countryCode: 'SJ' },
  Swaziland: { phonePrefix: '+268', countryCode: 'SZ' },
  Sweden: { phonePrefix: '+46', countryCode: 'SE' },
  Switzerland: { phonePrefix: '+41', countryCode: 'CH' },
  'Syrian Arab Republic': { phonePrefix: '+963', countryCode: 'SY' },
  Taiwan: { phonePrefix: '+886', countryCode: 'TW' },
  Tajikistan: { phonePrefix: '+992', countryCode: 'TJ' },
  Thailand: { phonePrefix: '+66', countryCode: 'TH' },
  'Timor-Leste': { phonePrefix: '+670', countryCode: 'TL' },
  Togo: { phonePrefix: '+228', countryCode: 'TG' },
  Tokelau: { phonePrefix: '+690', countryCode: 'TK' },
  Tonga: { phonePrefix: '+676', countryCode: 'TO' },
  'Trinidad and Tobago': { phonePrefix: '+1868', countryCode: 'TT' },
  Tunisia: { phonePrefix: '+216', countryCode: 'TN' },
  Turkey: { phonePrefix: '+90', countryCode: 'TR' },
  Turkmenistan: { phonePrefix: '+993', countryCode: 'TM' },
  'Turks and Caicos Islands': { phonePrefix: '+1649', countryCode: 'TC' },
  Tuvalu: { phonePrefix: '+688', countryCode: 'TV' },
  Uganda: { phonePrefix: '+256', countryCode: 'UG' },
  Ukraine: { phonePrefix: '+380', countryCode: 'UA' },
  'United Arab Emirates': { phonePrefix: '+971', countryCode: 'AE' },
  'United Kingdom': { phonePrefix: '+44', countryCode: 'GB' },
  'United States': { phonePrefix: '+1', countryCode: 'US' },
  Uruguay: { phonePrefix: '+598', countryCode: 'UY' },
  Uzbekistan: { phonePrefix: '+998', countryCode: 'UZ' },
  Vanuatu: { phonePrefix: '+678', countryCode: 'VU' },
  'Viet Nam': { phonePrefix: '+84', countryCode: 'VN' },
  'Virgin Islands, British': { phonePrefix: '+1284', countryCode: 'VG' },
  'Wallis and Futuna': { phonePrefix: '+681', countryCode: 'WF' },
  Yemen: { phonePrefix: '+967', countryCode: 'YE' },
  Zambia: { phonePrefix: '+260', countryCode: 'ZM' }
};

export const CountryCodeArray: Array<any> = [
  { country: 'Afghanistan', phonePrefix: '+93', countryCode: 'AF' },
  { country: 'Aland Islands', phonePrefix: '+358', countryCode: 'AX' },
  { country: 'Albania', phonePrefix: '+355', countryCode: 'AL' },
  { country: 'Algeria', phonePrefix: '+213', countryCode: 'DZ' },
  { country: 'Andorra', phonePrefix: '+376', countryCode: 'AD' },
  { country: 'Angola', phonePrefix: '+244', countryCode: 'AO' },
  { country: 'Anguilla', phonePrefix: '+1264', countryCode: 'AI' },
  { country: 'Antarctica', phonePrefix: '+672', countryCode: 'AQ' },
  { country: 'Antigua and Barbuda', phonePrefix: '+1268', countryCode: 'AG' },
  { country: 'Argentina', phonePrefix: '+54', countryCode: 'AR' },
  { country: 'Armenia', phonePrefix: '+374', countryCode: 'AM' },
  { country: 'Aruba', phonePrefix: '+297', countryCode: 'AW' },
  { country: 'Australia', phonePrefix: '+61', countryCode: 'AU' },
  { country: 'Austria', phonePrefix: '+43', countryCode: 'AT' },
  { country: 'Azerbaijan', phonePrefix: '+994', countryCode: 'AZ' },
  { country: 'Bahamas', phonePrefix: '+1242', countryCode: 'BS' },
  { country: 'Bahrain', phonePrefix: '+973', countryCode: 'BH' },
  { country: 'Bangladesh', phonePrefix: '+880', countryCode: 'BD' },
  { country: 'Barbados', phonePrefix: '+1246', countryCode: 'BB' },
  { country: 'Belgium', phonePrefix: '+32', countryCode: 'BE' },
  { country: 'Belize', phonePrefix: '+501', countryCode: 'BZ' },
  { country: 'Benin', phonePrefix: '+229', countryCode: 'BJ' },
  { country: 'Bermuda', phonePrefix: '+1441', countryCode: 'BM' },
  { country: 'Bhutan', phonePrefix: '+975', countryCode: 'BT' },
  { country: 'Bolivia, Plurinational State of', phonePrefix: '+591', countryCode: 'BO' },
  { country: 'Bosnia and Herzegovina', phonePrefix: '+387', countryCode: 'BA' },
  { country: 'Botswana', phonePrefix: '+267', countryCode: 'BW' },
  { country: 'Brazil', phonePrefix: '+55', countryCode: 'BR' },
  { country: 'British Indian Ocean Territory', phonePrefix: '+246', countryCode: 'IO' },
  { country: 'Brunei Darussalam', phonePrefix: '+673', countryCode: 'BN' },
  { country: 'Bulgaria', phonePrefix: '+359', countryCode: 'BG' },
  { country: 'Burkina Faso', phonePrefix: '+226', countryCode: 'BF' },
  { country: 'Burundi', phonePrefix: '+257', countryCode: 'BI' },
  { country: 'Cambodia', phonePrefix: '+855', countryCode: 'KH' },
  { country: 'Cameroon', phonePrefix: '+237', countryCode: 'CM' },
  { country: 'Canada', phonePrefix: '+1', countryCode: 'CA' },
  { country: 'Cape Verde', phonePrefix: '+238', countryCode: 'CV' },
  { country: 'Cayman Islands', phonePrefix: '+ 345', countryCode: 'KY' },
  { country: 'Central African Republic', phonePrefix: '+236', countryCode: 'CF' },
  { country: 'Chad', phonePrefix: '+235', countryCode: 'TD' },
  { country: 'Chile', phonePrefix: '+56', countryCode: 'CL' },
  { country: 'China', phonePrefix: '+86', countryCode: 'CN' },
  { country: 'Christmas Island', phonePrefix: '+61', countryCode: 'CX' },
  { country: 'Cocos (Keeling) Islands', phonePrefix: '+61', countryCode: 'CC' },
  { country: 'Colombia', phonePrefix: '+57', countryCode: 'CO' },
  { country: 'Comoros', phonePrefix: '+269', countryCode: 'KM' },
  { country: 'Congo', phonePrefix: '+242', countryCode: 'CG' },
  { country: 'Cook Islands', phonePrefix: '+682', countryCode: 'CK' },
  { country: 'Costa Rica', phonePrefix: '+506', countryCode: 'CR' },
  { country: "Cote d'Ivoire", phonePrefix: '+225', countryCode: 'CI' },
  { country: 'Croatia', phonePrefix: '+385', countryCode: 'HR' },
  { country: 'Cuba', phonePrefix: '+53', countryCode: 'CU' },
  { country: 'Cyprus', phonePrefix: '+357', countryCode: 'CY' },
  { country: 'Czech Republic', phonePrefix: '+420', countryCode: 'CZ' },
  { country: 'Denmark', phonePrefix: '+45', countryCode: 'DK' },
  { country: 'Djibouti', phonePrefix: '+253', countryCode: 'DJ' },
  { country: 'Dominica', phonePrefix: '+1767', countryCode: 'DM' },
  { country: 'Dominican Republic', phonePrefix: '+1849', countryCode: 'DO' },
  { country: 'Ecuador', phonePrefix: '+593', countryCode: 'EC' },
  { country: 'Egypt', phonePrefix: '+20', countryCode: 'EG' },
  { country: 'El Salvador', phonePrefix: '+503', countryCode: 'SV' },
  { country: 'Equatorial Guinea', phonePrefix: '+240', countryCode: 'GQ' },
  { country: 'Eritrea', phonePrefix: '+291', countryCode: 'ER' },
  { country: 'Estonia', phonePrefix: '+372', countryCode: 'EE' },
  { country: 'Ethiopia', phonePrefix: '+251', countryCode: 'ET' },
  { country: 'Falkland Islands (Malvinas)', phonePrefix: '+500', countryCode: 'FK' },
  { country: 'Faroe Islands', phonePrefix: '+298', countryCode: 'FO' },
  { country: 'Fiji', phonePrefix: '+679', countryCode: 'FJ' },
  { country: 'Finland', phonePrefix: '+358', countryCode: 'FI' },
  { country: 'France', phonePrefix: '+33', countryCode: 'FR' },
  { country: 'French Guiana', phonePrefix: '+594', countryCode: 'GF' },
  { country: 'French Polynesia', phonePrefix: '+689', countryCode: 'PF' },
  { country: 'Gabon', phonePrefix: '+241', countryCode: 'GA' },
  { country: 'Gambia', phonePrefix: '+220', countryCode: 'GM' },
  { country: 'Georgia', phonePrefix: '+995', countryCode: 'GE' },
  { country: 'Germany', phonePrefix: '+49', countryCode: 'DE' },
  { country: 'Ghana', phonePrefix: '+233', countryCode: 'GH' },
  { country: 'Gibraltar', phonePrefix: '+350', countryCode: 'GI' },
  { country: 'Greece', phonePrefix: '+30', countryCode: 'GR' },
  { country: 'Greenland', phonePrefix: '+299', countryCode: 'GL' },
  { country: 'Grenada', phonePrefix: '+1473', countryCode: 'GD' },
  { country: 'Guadeloupe', phonePrefix: '+590', countryCode: 'GP' },
  { country: 'Guam', phonePrefix: '+1671', countryCode: 'GU' },
  { country: 'Guatemala', phonePrefix: '+502', countryCode: 'GT' },
  { country: 'Guernsey', phonePrefix: '+44', countryCode: 'GG' },
  { country: 'Guinea', phonePrefix: '+224', countryCode: 'GN' },
  { country: 'Guinea-Bissau', phonePrefix: '+245', countryCode: 'GW' },
  { country: 'Guyana', phonePrefix: '+595', countryCode: 'GY' },
  { country: 'Haiti', phonePrefix: '+509', countryCode: 'HT' },
  { country: 'Holy See (Vatican City State)', phonePrefix: '+379', countryCode: 'VA' },
  { country: 'Honduras', phonePrefix: '+504', countryCode: 'HN' },
  { country: 'Hong Kong', phonePrefix: '+852', countryCode: 'HK' },
  { country: 'Hungary', phonePrefix: '+36', countryCode: 'HU' },
  { country: 'Iceland', phonePrefix: '+354', countryCode: 'IS' },
  { country: 'India', phonePrefix: '+91', countryCode: 'IN' },
  { country: 'Indonesia', phonePrefix: '+62', countryCode: 'ID' },
  { country: 'Iraq', phonePrefix: '+964', countryCode: 'IQ' },
  { country: 'Ireland', phonePrefix: '+353', countryCode: 'IE' },
  { country: 'Isle of Man', phonePrefix: '+44', countryCode: 'IM' },
  { country: 'Israel', phonePrefix: '+972', countryCode: 'IL' },
  { country: 'Italy', phonePrefix: '+39', countryCode: 'IT' },
  { country: 'Jamaica', phonePrefix: '+1876', countryCode: 'JM' },
  { country: 'Japan', phonePrefix: '+81', countryCode: 'JP' },
  { country: 'Jersey', phonePrefix: '+44', countryCode: 'JE' },
  { country: 'Jordan', phonePrefix: '+962', countryCode: 'JO' },
  { country: 'Kazakhstan', phonePrefix: '+77', countryCode: 'KZ' },
  { country: 'Kenya', phonePrefix: '+254', countryCode: 'KE' },
  { country: 'Kiribati', phonePrefix: '+686', countryCode: 'KI' },
  { country: 'Kuwait', phonePrefix: '+965', countryCode: 'KW' },
  { country: 'Kyrgyzstan', phonePrefix: '+996', countryCode: 'KG' },
  { country: 'Latvia', phonePrefix: '+371', countryCode: 'LV' },
  { country: 'Lebanon', phonePrefix: '+961', countryCode: 'LB' },
  { country: 'Lesotho', phonePrefix: '+266', countryCode: 'LS' },
  { country: 'Liberia', phonePrefix: '+231', countryCode: 'LR' },
  { country: 'Liechtenstein', phonePrefix: '+423', countryCode: 'LI' },
  { country: 'Lithuania', phonePrefix: '+370', countryCode: 'LT' },
  { country: 'Luxembourg', phonePrefix: '+352', countryCode: 'LU' },
  { country: 'Macao', phonePrefix: '+853', countryCode: 'MO' },
  { country: 'Madagascar', phonePrefix: '+261', countryCode: 'MG' },
  { country: 'Malawi', phonePrefix: '+265', countryCode: 'MW' },
  { country: 'Malaysia', phonePrefix: '+60', countryCode: 'MY' },
  { country: 'Maldives', phonePrefix: '+960', countryCode: 'MV' },
  { country: 'Mali', phonePrefix: '+223', countryCode: 'ML' },
  { country: 'Malta', phonePrefix: '+356', countryCode: 'MT' },
  { country: 'Marshall Islands', phonePrefix: '+692', countryCode: 'MH' },
  { country: 'Martinique', phonePrefix: '+596', countryCode: 'MQ' },
  { country: 'Mauritania', phonePrefix: '+222', countryCode: 'MR' },
  { country: 'Mauritius', phonePrefix: '+230', countryCode: 'MU' },
  { country: 'Mayotte', phonePrefix: '+262', countryCode: 'YT' },
  { country: 'Mexico', phonePrefix: '+52', countryCode: 'MX' },
  { country: 'Monaco', phonePrefix: '+377', countryCode: 'MC' },
  { country: 'Mongolia', phonePrefix: '+976', countryCode: 'MN' },
  { country: 'Montenegro', phonePrefix: '+382', countryCode: 'ME' },
  { country: 'Montserrat', phonePrefix: '+1664', countryCode: 'MS' },
  { country: 'Morocco', phonePrefix: '+212', countryCode: 'MA' },
  { country: 'Mozambique', phonePrefix: '+258', countryCode: 'MZ' },
  { country: 'Namibia', phonePrefix: '+264', countryCode: 'NA' },
  { country: 'Nauru', phonePrefix: '+674', countryCode: 'NR' },
  { country: 'Nepal', phonePrefix: '+977', countryCode: 'NP' },
  { country: 'Netherlands', phonePrefix: '+31', countryCode: 'NL' },
  { country: 'New Caledonia', phonePrefix: '+687', countryCode: 'NC' },
  { country: 'New Zealand', phonePrefix: '+64', countryCode: 'NZ' },
  { country: 'Nicaragua', phonePrefix: '+505', countryCode: 'NI' },
  { country: 'Niger', phonePrefix: '+227', countryCode: 'NE' },
  { country: 'Niue', phonePrefix: '+683', countryCode: 'NU' },
  { country: 'Norfolk Island', phonePrefix: '+672', countryCode: 'NF' },
  { country: 'Northern Mariana Islands', phonePrefix: '+1670', countryCode: 'MP' },
  { country: 'Norway', phonePrefix: '+47', countryCode: 'NO' },
  { country: 'Oman', phonePrefix: '+968', countryCode: 'OM' },
  { country: 'Pakistan', phonePrefix: '+92', countryCode: 'PK' },
  { country: 'Palau', phonePrefix: '+680', countryCode: 'PW' },
  { country: 'Panama', phonePrefix: '+507', countryCode: 'PA' },
  { country: 'Papua New Guinea', phonePrefix: '+675', countryCode: 'PG' },
  { country: 'Paraguay', phonePrefix: '+595', countryCode: 'PY' },
  { country: 'Peru', phonePrefix: '+51', countryCode: 'PE' },
  { country: 'Philippines', phonePrefix: '+63', countryCode: 'PH' },
  { country: 'Pitcairn', phonePrefix: '+872', countryCode: 'PN' },
  { country: 'Poland', phonePrefix: '+48', countryCode: 'PL' },
  { country: 'Portugal', phonePrefix: '+351', countryCode: 'PT' },
  { country: 'Puerto Rico', phonePrefix: '+1939', countryCode: 'PR' },
  { country: 'Qatar', phonePrefix: '+974', countryCode: 'QA' },
  { country: 'Reunion', phonePrefix: '+262', countryCode: 'RE' },
  { country: 'Romania', phonePrefix: '+40', countryCode: 'RO' },
  { country: 'Rwanda', phonePrefix: '+250', countryCode: 'RW' },
  { country: 'Saint Kitts and Nevis', phonePrefix: '+1869', countryCode: 'KN' },
  { country: 'Saint Lucia', phonePrefix: '+1758', countryCode: 'LC' },
  { country: 'Saint Pierre and Miquelon', phonePrefix: '+508', countryCode: 'PM' },
  { country: 'Saint Vincent and the Grenadines', phonePrefix: '+1784', countryCode: 'VC' },
  { country: 'Samoa', phonePrefix: '+685', countryCode: 'WS' },
  { country: 'San Marino', phonePrefix: '+378', countryCode: 'SM' },
  { country: 'Sao Tome and Principe', phonePrefix: '+239', countryCode: 'ST' },
  { country: 'Saudi Arabia', phonePrefix: '+966', countryCode: 'SA' },
  { country: 'Senegal', phonePrefix: '+221', countryCode: 'SN' },
  { country: 'Serbia', phonePrefix: '+381', countryCode: 'RS' },
  { country: 'Seychelles', phonePrefix: '+248', countryCode: 'SC' },
  { country: 'Sierra Leone', phonePrefix: '+232', countryCode: 'SL' },
  { country: 'Singapore', phonePrefix: '+65', countryCode: 'SG' },
  { country: 'Slovakia', phonePrefix: '+421', countryCode: 'SK' },
  { country: 'Slovenia', phonePrefix: '+386', countryCode: 'SI' },
  { country: 'Solomon Islands', phonePrefix: '+677', countryCode: 'SB' },
  { country: 'Somalia', phonePrefix: '+252', countryCode: 'SO' },
  { country: 'South Africa', phonePrefix: '+27', countryCode: 'ZA' },
  {
    country: 'South Georgia and the South Sandwich Islands',
    phonePrefix: '+500',
    countryCode: 'GS'
  },
  { country: 'South Sudan', phonePrefix: '+211', countryCode: 'SS' },
  { country: 'Spain', phonePrefix: '+34', countryCode: 'ES' },
  { country: 'Sri Lanka', phonePrefix: '+94', countryCode: 'LK' },
  { country: 'Sudan', phonePrefix: '+249', countryCode: 'SD' },
  { country: 'Suriname', phonePrefix: '+597', countryCode: 'SR' },
  { country: 'Svalbard and Jan Mayen', phonePrefix: '+47', countryCode: 'SJ' },
  { country: 'Swaziland', phonePrefix: '+268', countryCode: 'SZ' },
  { country: 'Sweden', phonePrefix: '+46', countryCode: 'SE' },
  { country: 'Switzerland', phonePrefix: '+41', countryCode: 'CH' },
  { country: 'Syrian Arab Republic', phonePrefix: '+963', countryCode: 'SY' },
  { country: 'Taiwan', phonePrefix: '+886', countryCode: 'TW' },
  { country: 'Tajikistan', phonePrefix: '+992', countryCode: 'TJ' },
  { country: 'Thailand', phonePrefix: '+66', countryCode: 'TH' },
  { country: 'Timor-Leste', phonePrefix: '+670', countryCode: 'TL' },
  { country: 'Togo', phonePrefix: '+228', countryCode: 'TG' },
  { country: 'Tokelau', phonePrefix: '+690', countryCode: 'TK' },
  { country: 'Tonga', phonePrefix: '+676', countryCode: 'TO' },
  { country: 'Trinidad and Tobago', phonePrefix: '+1868', countryCode: 'TT' },
  { country: 'Tunisia', phonePrefix: '+216', countryCode: 'TN' },
  { country: 'Turkey', phonePrefix: '+90', countryCode: 'TR' },
  { country: 'Turkmenistan', phonePrefix: '+993', countryCode: 'TM' },
  { country: 'Turks and Caicos Islands', phonePrefix: '+1649', countryCode: 'TC' },
  { country: 'Tuvalu', phonePrefix: '+688', countryCode: 'TV' },
  { country: 'Uganda', phonePrefix: '+256', countryCode: 'UG' },
  { country: 'Ukraine', phonePrefix: '+380', countryCode: 'UA' },
  { country: 'United Arab Emirates', phonePrefix: '+971', countryCode: 'AE' },
  { country: 'United Kingdom', phonePrefix: '+44', countryCode: 'GB' },
  { country: 'United States', phonePrefix: '+1', countryCode: 'US' },
  { country: 'Uruguay', phonePrefix: '+598', countryCode: 'UY' },
  { country: 'Uzbekistan', phonePrefix: '+998', countryCode: 'UZ' },
  { country: 'Vanuatu', phonePrefix: '+678', countryCode: 'VU' },
  { country: 'Virgin Islands, British', phonePrefix: '+1284', countryCode: 'VG' },
  { country: 'Wallis and Futuna', phonePrefix: '+681', countryCode: 'WF' },
  { country: 'Yemen', phonePrefix: '+967', countryCode: 'YE' },
  { country: 'Zambia', phonePrefix: '+260', countryCode: 'ZM' }
];
